export default __webpack_public_path__ + "static/media/bunk_bed.3b9012cc.svg";